import React, { useContext, useEffect, useRef } from 'react'
import { store } from '../../stores/pages'

export default function PageForm({children}) {
  const { actions, dispatch } = useContext(store)
  const formRef = useRef(null)

  useEffect(() => {
    dispatch({ type: actions.SET_FORM_REF, payload: formRef.current })
  }, [formRef.current])


  return (
    <form className="producer-form-fields" ref={formRef}>
      {children}
    </form>
  )
}
